import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";


const styles = createUseStyles(theme => ({
  footer: {
    display: "grid",
    gap: "24px",
    width: "100%",
    marginTop: "auto !important",
    marginBottom: "32px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      gap: "8px"
    },
  },
  manageCompanyfooter: {
    [`@media (min-width: ${breakpoints.md}px)`]: {
      marginBottom: "84px"
    },
  },
  bookTravel: {
    display: "flex",
    alignItems: "center",
    margin: "0px 16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
    "& :focus:not(.focus-visible)":{
      outline:"none",
    },

    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover:not(.active)": {
      cursor: "pointer",
      backgroundColor: theme.navigation.li.active.backgroundColor,
      "& a":{
        color: theme.navigation.li.active.color,
      },
      "& svg": {
        "& path": {
          stroke: theme.navigationIcon.hover.stroke,
        },
      },
    },
    "& a": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: theme.navigation.li.default.color,
      padding: "8px 12px",
      borderRadius: "4px",
      "& div": {
        alignSelf: "center",
        marginLeft: "14px",
      },
    },
  },
  help: {
    display: "flex",
    alignItems: "center",
    margin: "0px 16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
    "& :focus:not(.focus-visible)":{
      outline:"none",
    },

    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover:not(.active)": {
      cursor: "pointer",
      backgroundColor: theme.navigation.li.active.backgroundColor,
      color: theme.navigation.li.active.color,
      borderRadius: "4px",
      "& a":{
        color: theme.navigation.li.active.color,
      },
      "& svg": {
        "& path": {
          stroke: theme.navigationIcon.hover.stroke,
        }
      }
    },
    "& a": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: theme.navigation.li.default.color,
      padding: "8px 12px",
      borderRadius: "4px",
      "& div": {
        alignSelf: "center",
        marginLeft: "14px",
      },
      "& svg": {
        "& path": {
          stroke: theme.navigationIcon.stroke,
        }
      },
    },
  },
  lang: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
    "& :focus:not(.focus-visible)":{
      outline:0,
    },
    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover:not(.active)": {
      cursor: "pointer",
      backgroundColor: theme.navigation.li.active.backgroundColor,
      "& a":{
        color: theme.navigation.li.active.color,
      },
    },

    "& .langSelector": {
      display: "flex",
      alignItems: "center",
      width: "100%",
      textDecoration: "none",
      color: colors.grey,
      padding: "8px 12px",
      borderRadius: "4px",
      [`@media (max-width: ${breakpoints.md}px)`]: {
        paddingTop: "25px",
        "&:hover": {
          padding: "8px 12px",
        },
      },
      "&:hover": {
        color: theme.navigation.li.active.color,
      },
      "& div": {
        marginLeft: "16px",
        alignSelf: "center",
      },
    },
  },
  companyLang:{
    margin: "0px 16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
  },
  locale: {
    color: theme.navigation.li.default.color,
    "&:hover": {
      color: theme.navigation.li.active.color,
    },
  },
  profileAdmin: {
    display: "flex",
    margin: "0px 16px",
    "&:hover:not(.active)": {
      cursor: "pointer",
      backgroundColor: theme.navigation.li.active.backgroundColor,
      "& a":{
        color: theme.navigation.li.active.color,
      },
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
  },
  profile: {
    display: "flex",
    padding: "24px 16px 0px 24px",
    borderTop: "1px solid " + colors.lightGrey,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "24px 8px 0px 16px"
    },
  },
  footerBannerProfileStyle: {
    marginBottom: "16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "30px",
    },
  },
  profileBannerPadding: {
    paddingBottom: "24px",
  },
  profileAvatar: {
    alignSelf: "center",
    minWidth: "40px",
    minHeight: "40px",
    background: theme.navigation.profileAvatar.backgroundColor,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& span": {
      color: theme.navigation.profileAvatar.color,
    },
    border: theme.navigation.profileAvatar.border
  },
  profileDetails: {
    marginLeft: "12px",
    marginRight: "6px",
    "& p": {
      margin: 0,
      fontSize: "14px"
    },
    "& p:first-child": {
      color: theme.navigation.li.default.color,
      fontWeight: "600",
      lineHeight: "20px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "140px",
      whiteSpace: "nowrap",
    },
    "& p:last-child": {
      color: theme.navigation.companyName.color,
      fontWeight: "400",
      lineHeight: "20px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "140px",
      whiteSpace: "nowrap",
    }
  },
  profileAction: {
    marginLeft: "auto",
    cursor: "pointer"
  },
  overlayLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: theme.navigation.color,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    padding: "10px",
    "&:hover": {
      color: theme.navigation.li.active.color, // colors.grey,
      backgroundColor: theme.navigation.li.active.backgroundColor,
      borderRadius: "8px",
      "& svg": {
        "& path": {
          stroke: theme.navigationIcon.hover.stroke,
        }
      }
    },
    width: "100%",
  },
  adminLogoutLink: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    padding: "8px 12px",
    textDecoration: "none",
    color: theme.navigation.color,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    "&:hover": {
      color: theme.navigation.li.active.color,
      "& svg":{
        "& path": {
          stroke: theme.navigationIcon.hover.stroke,
        },
      }
    },    
    width: "100%",
  },
  popoverStyle:{
    border: "none",
    "& .popover-arrow": {
      display: "none !important",
    },
    [`@media (min-width: ${breakpoints.md}px)`]: {
      translate:"-100px 0",
    },
    [`@media only screen and (width: ${breakpoints.md}px)`]: {
      translate:"-8px 0",
    },
  },
  popoverDiv:{
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-start",
    backgroundColor: theme.navigation.backgroundColor, //colors.white,
    padding: "6px",
    width:"240px",
    border: `1px solid ${colors.lightGrey}`,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    right: "100%",
    '& span': {
      display: "block"
    }
  },
  popoverImage: {
    marginRight: "13px",
    "& path": {
      stroke: theme.navigationIcon.stroke
    },
  },
  dotsStyle:{
    display:"flex",
    alignItems:"center",
    cursor: "pointer",
    "& svg":{
      marginTop: "-7px",
      "& path": {
        stroke: theme.navigation.li.default.color,
      }
    },
    "&:hover": {
      "& path": {
        stroke: theme.navigation.li.active.color,
      }
    },
    "&:focus": {
      "& path": {
        stroke: theme.navigation.li.default.color,
      }
    },
  },
  dotsOpenStyle: {
    "& path": {
      stroke: theme.navigation.li.active.color,
    }
  },
  links: {
    display: "grid",
    gap: "4px"
  },
  terms: {
    display: "flex",
    alignItems: "center",
    margin: "0px 16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0px 8px",
    },
    "& :focus:not(.focus-visible)":{
      outline:"none",
    },

    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover:not(.active)": {
      cursor: "pointer",
      backgroundColor: theme.navigation.li.active.backgroundColor,
      "& a":{
        color: theme.navigation.li.active.color,
      },
    },
    "& a": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: colors.paleGrey,
      borderRadius: "4px",
      lineHeight: "18px",
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 12px",
      "& div": {
        alignSelf: "center",
      },
    },
  },
  privacyDiv:{
    display: "flex",
    justifyContent: "center",
    marginTop: "-10px",
    flexDirection: "column",
    padding: "0px 16px",
    marginBottom: "-8px"
  },
  privacyStyle:{

  },
  poweredBy:{
    color: colors.choiceIconGray,
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    marginTop: "8px",
  },
  arcLink:{
    color: theme.privacyOptions.textColor,
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "18px",
    textDecoration: "none",
    marginLeft: "4px",
  },
}));

export default styles;

export const selectPrivacyStyle = theme => ({
  control: (base, { selectProps }) => ({
    ...base,
    minHeight: "32px",
    width: "247px",
    maxWidth: "247px",
    fontSize: "12px",
    fontWeight: 600,
    borderRadius: "8px",
    color: theme.privacyOptions.textColor,
    border: theme.privacyOptions.border ?? "1px solid " + theme.privacyOptions.borderColor,
    cursor: "pointer",
    boxShadow: "none",
    backgroundColor: selectProps.menuIsOpen ? theme.privacyOptions.backgroundColorHover : theme.privacyOptions.backgroundColor,
    "&:hover": {
      border: theme.privacyOptions.border ?? "1px solid " + theme.privacyOptions.borderColor,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      minHeight: "32px",
    },
  }),
  placeholder:
    (base, state) => ({
      ...base,
      color: theme.privacyOptions.textColor,
      fontSize: "12px",
      fontWeight: 600,
    }),
  option:
    (base, state) => ({
      ...base,
      color: theme.privacyOptions.textColor,
      fontSize: "12px",
      fontWeight: 500,
      padding: "7px 12px",
      backgroundColor: state.isFocused ? theme.privacyOptions.backgroundColorHover : theme.privacyOptions.backgroundColor,
      "&:hover": {
        backgroundColor: theme.privacyOptions.textHover,
        color: theme.navigation.li.active.color,
      },
      "&:active": {
        backgroundColor: theme.privacyOptions.backgroundColorHover,
      },
      "& img": {
        display: "none",
      },
    }),
  menu:
    (base) => ({
      ...base,
      borderRadius: "8px",
      marginTop: "3px",
      width: "247px",
      backgroundColor: theme.privacyOptions.backgroundColor,
      boxShadow: "none"
    }),
  singleValue:
    (base) => ({
      ...base,
      color: theme.privacyOptions.textColor,
      fontSize: "12px",
      fontWeight: 600,
    }),
  menuList:
    (base) => ({
      ...base,
      maxHeight: "150px",
      borderRadius: "8px",
      border: "1px solid " + theme.privacyOptions.borderColor,
    }),
  dropdownIndicator:
    (base,{ selectProps }) => ({
      ...base,
      paddingLeft: "12px",
      color: theme.privacyOptions.textColor,
      transition: selectProps.menuIsOpen ? 'all .2s ease' : 'none',
      transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
      "&:hover": {
        color: `${theme.privacyOptions.textColor} !important`,
      }
    }),
  indicatorSeparator:
    (base) => ({
      ...base,
      width: "0px",
    }),
})
